import React, { useEffect } from "react";
import { Outlet, useParams, useNavigate, useLocation } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";

const VALID_LANGUAGES = ['en', 'sv'] as const;

// Routes that should not be treated as language prefixes
const NON_LANGUAGE_ROUTES = [
  'features', 'pricing', 'about', 'contact', 'demo', 'blog', 
  'privacy', 'terms', 'cookies', 'careers', 'api-documentation', 
  'business-cases', 'book-meeting', 'faq'
];

const LanguageLayout = () => {
  const { lang } = useParams<{ lang?: string }>();
  const { language, setLanguage } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (lang && VALID_LANGUAGES.includes(lang as any)) {
      // Valid language prefix - update context
      if (language !== lang) {
        setLanguage(lang as 'en' | 'sv');
      }
    } else if (lang && NON_LANGUAGE_ROUTES.includes(lang)) {
      // This is a route, not a language - don't change language
      return;
    } else if (lang && !VALID_LANGUAGES.includes(lang as any) && !NON_LANGUAGE_ROUTES.includes(lang)) {
      // Invalid language prefix that's not a known route - redirect to home
      navigate('/', { replace: true });
    }
  }, [lang, language, setLanguage, navigate]);

  return <Outlet />;
};

export default LanguageLayout;
